// extracted by mini-css-extract-plugin
export default {"boldText":"sfqDod","radioContainer":"lE6j0e"};